/**
 * Get List
 */
export const GET_ARTICLE_TYPE = "web/GET_ARTICLE_TYPE";
export const GET_ARTICLE_TYPE_SUCCESS = "web/GET_ARTICLE_TYPE_SUCCESS";
export const GET_ARTICLE_TYPE_FAILURE = "web/GET_ARTICLE_TYPE_FAILURE";
